import DebounecedAutocomplete from './DebounecedAutocomplete';

export type { IDebounecedAutocompleteProps } from './DebounecedAutocomplete.types';
export default DebounecedAutocomplete;
